import { Component, OnInit, Input, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DialogEditTextComponent } from 'src/app/shared/dialogs/dialog-edit-text/dialog-edit-text.component';
import { OrderFacade } from 'src/app/store/order/facade';
import { OrderModel, RequestActDTO } from 'src/app/store/order/model';

@Component({
  selector: 'app-order-tab-actions',
  templateUrl: './order-tab-actions.component.html',
  styleUrls: ['./order-tab-actions.component.scss'],
  standalone: false,
})
export class OrderTabActionsComponent implements OnInit {
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);

  @Input() order: OrderModel;

  @ViewChild(DialogEditTextComponent) dialogEditText: DialogEditTextComponent;
  acts$: Observable<RequestActDTO[]>;
  actionAddingText: string;

  ngOnInit(): void {
    this.acts$ = this.orderFacade.acts$;

    if (this.order && this.order.id) {
      this.orderFacade.loadActs(this.order.id);
    }

    this.translate.get('ACTION_ADDING').subscribe(value => {
      this.actionAddingText = value;
    });
  }

  addAction() {
    if (this.dialogEditText) {
      this.dialogEditText.execute(this.actionAddingText, null, '').subscribe(result => {
        if (result) {
          this.orderFacade.createAct(this.order.id, this.dialogEditText.value);
        }
      });
    } else {
      alert('DialogEditTextComponent not found');
    }
  }
}
